import { Box, BoxProps } from "@chakra-ui/react";
import { useEffect, useRef } from "react";

export const ScrollToWhenVisible = ({ children, ...boxProps }: BoxProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const hasScrolled = useRef(false);

  useEffect(() => {
    if (hasScrolled.current === true) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry !== undefined && !entry.isIntersecting) {
          ref.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          hasScrolled.current = true;
          observer.disconnect();
        }
      },
      {
        threshold: 1.0, // Fully visible
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <Box ref={ref} {...boxProps}>
      {children}
    </Box>
  );
};
